import Vue from 'vue';
import { mapGetters } from 'vuex';
const popupChunksRequires = require.context('@/components/', true, /\.popup-chunk\.vue$/i);
const popupChunks = popupChunksRequires.keys().reduce((acc, curr) => {
    const parsed = require('@/components/' + curr.substring(2));
    acc[parsed.default.extendOptions.name] = parsed.default;
    return acc;
}, {});
function keyupEnterHandler() {
    const accentActions = this.popupState.actions.filter((action) => action.isAccent);
    if (accentActions.length === 1) {
        accentActions[0].callback();
    }
}
export default Vue.extend({
    name: 'Popup',
    computed: Object.assign({}, mapGetters('popupModule', {
        isActive: 'getPopupIsOpened',
        popupState: 'getActivePopup'
    })),
    created() {
        const vm = this;
        document.addEventListener('keyup', (event) => {
            if (!this.isActive || typeof (event === null || event === void 0 ? void 0 : event.key) !== 'string')
                return;
            switch (event.key.toLowerCase()) {
                case 'escape': {
                    if (this.letDefaultClose)
                        vm.$store.commit('popupModule/setClosed');
                    break;
                }
                case 'enter': {
                    keyupEnterHandler.call(this);
                    break;
                }
                default: {
                }
            }
        });
    },
    components: popupChunks
});
